import moment from "jalali-moment";
import React, { Fragment, useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Color } from "../../Utils/styles";
import BugReportModal from "../Common/BugReportModal";
import {
  checkToday,
  compaireTwoTime,
  differenceToTimeSecounds,
} from "../Common/Function";
import Loading from "../Common/Loading";
import Support from "../Common/Support";
import Footer from "../Components/Footer";
import Header from "../Components/Header";
import Slider from "react-slick";
import { AiFillCaretLeft, AiFillCaretRight } from "react-icons/ai";
export default function App(props) {
  const { basket, popUp, user_type, footerDetails } = useSelector(
    state => state
  );
  const dispatch = useDispatch();
  let location = useLocation();

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  useEffect(() => {
    scrollToTop();
    checkBasket();
    checkSupport();
  }, [location.pathname]);

  let arr = [
    "/exiteacount",
    "/adminnloginn",
    "/UserLogin",
    "/check",
    "/SignUp",
    "/VeryfyCode",
    "/ForgetPassword",
    "/card",
    "/ticket",
    "/pay/result",
  ];
  // console.log("lc", location.pathname);
  const MINUTE_MS = 1000 * 60 * 12;

  useEffect(() => {
    const interval = setInterval(() => {
      checkBasket();
    }, MINUTE_MS);

    return () => clearInterval(interval);
  }, []);
  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     checkSupport();
  //   }, 1000 * 5);
  //   return () => clearInterval(interval);
  // }, []);
  useEffect(() => {
    if (!popUp && (user_type == "user" || !user_type)) {
      createPopUp();
    }
  }, []);
  const createPopUp = () => {
    if (!popUp && (user_type == "user" || !user_type)) {
      let obj = {
        isCall: "ali",
        start: moment(),
        status: false,
      };
      dispatch({
        local_storage: {
          key: "popUp",
          value: {
            ...obj,
          },
        },
        type: "SET",
        payload: {
          popUp: {
            ...obj,
          },
        },
      });
    }
  };
  const navigate = useNavigate();
  // console.log("lpca", location);
  if (
    location.pathname ==
    "/Items/%D8%B3%D8%A7%D9%84%D9%86-%D8%A8%D9%87%D8%A7%D8%B1%D8%B3%D8%AA%D8%A7%D9%86"
  ) {
    navigate("/salon/shahrud/سالن-بهارستان-شاهرود");
  }
  const checkBasket = async () => {
    if (!compaireTwoTime(basket.expiryTime)) {
      await dispatch({
        local_storage: {
          key: "basket",
          value: {},
        },
        type: "SET",
        payload: { basket: {} },
      });
    }
  };
  const checkSupport = async () => {
    if (popUp && popUp.start) {
      if (checkToday(popUp.start)) {
        if (differenceToTimeSecounds(popUp.start) > 60 * 5 * 1000) {
          if (popUp.isCall === "ali") {
            let obj = {
              ...popUp,
              status: true,
            };
            await dispatch({
              local_storage: {
                key: "popUp",
                value: {
                  ...obj,
                },
              },
              type: "SET",
              payload: {
                popUp: {
                  ...obj,
                },
              },
            });
          }
        }
      } else {
        createPopUp();
      }
    }
  };

  return (
    <Fragment>
      <Helmet>
        <link rel="icon" type="image/png" href="favicon.ico" />
        <link
          rel="stylesheet"
          href={
            window.origin +
            "/WebSide/assets/libs/Bootstrap5/css/bootstrap.rtl.min.css"
          }
        />
        <link
          rel="stylesheet"
          href={window.origin + "/WebSide/assets/css/main.css"}
        />

        <link
          rel="stylesheet"
          href={window.origin + "/font/Vida/css/vidaicon.css"}
        />
      </Helmet>
      {props.noFoooter ? "" : <Header />}
      {props.children}
      {[
        "/exiteacount",
        "/adminnloginn",
        "/UserLogin",
        "/check",
        "/SignUp",
        "/VeryfyCode",
        "/ForgetPassword",
        "/card",
        "/ticket",
        "/pay/result",
      ].includes(location.pathname) ? (
        <></>
      ) : (
        <LastBlogs />
      )}

      {props.noFoooter ? "" : <Footer noMargin={props.noMargin} />}

      <BugReportModal />
      <Support />
    </Fragment>
  );
}
const LastBlogs = () => {
  const { footerDetails } = useSelector(state => state);
  const [show, setShow] = useState(true);
  // console.log("fo", footerDetails);
  if (!footerDetails) {
    return (
      <div style={{ position: "fixed", bottom: "10px", left: "10px" }}>
        <Loading height="100" count={1} />
      </div>
    );
  }
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    infinite: true,
    arrows: false,
    delay: 2000,
  };
  return (
    <div className="last-blogs-wrapper">
      <div id="last-blogs" className={`${show ? "" : "w-10"} `}>
        <Slider {...settings}>
          {footerDetails.blogs.map(blog => {
            return (
              <div className="last-blog-card">
                <div className="last-blog-card-box">
                  <Link style={{ flex: 1 }} to={`/Blogs/${blog && blog.slug}`}>
                    <div style={{}}>
                      <img src={blog.images[0]} />
                    </div>
                    <div className={`fade-she`} style={{ flex: 3 }}>
                      <div className="last-blog-title">
                        <h6>{blog.title}</h6>
                      </div>
                      <div className="last-blog-content">
                        <p>
                          {blog && blog.description.toString().length > 90
                            ? `${blog.description.toString().substr(0, 70)}`
                            : blog.description}
                        </p>
                      </div>
                    </div>
                  </Link>

                  <div
                    onClick={() => {
                      window.$(".fade-she").fadeToggle(500);
                      setTimeout(() => {
                        setShow(!show);
                      }, 500);
                    }}
                    className="icon-minimize"
                  >
                    <button className="icon-minimize">
                      {show ? <AiFillCaretLeft /> : <AiFillCaretRight />}
                    </button>
                  </div>
                </div>
              </div>
            );
          })}
        </Slider>
      </div>
    </div>
  );
};
